// src/services/views.ts
import { apiJson } from './http';

export type Page<T> = {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number; // page index
  size: number;   // page size
};

export type ViewsDTO = {
  id: number;
  value: number;
  customerId: number;
  createdAt?: string | null;
  notes?: string | null;
};

/* ------------- Views (PRIVATE /p/views) ------------- */

/** Crea una nuova riga di “views” per un customer */
export async function createViews(payload: { value: number; customerId: number; notes?: string | null }) {
  return apiJson<ViewsDTO>('/p/views', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/** Lista paginata per customer (ordinate per createdAt DESC lato BE) */
export async function listViewsByCustomer(customerId: number, page = 0, size = 20) {
  return apiJson<Page<ViewsDTO>>(`/p/views/customer/${customerId}?page=${page}&size=${size}`);
}

/** Ultima riga (più recente) per customer */
export async function getLatestViewsByCustomer(customerId: number) {
  return apiJson<ViewsDTO>(`/p/views/customer/${customerId}/latest`);
}

/** Elimina logicamente una riga di views */
export async function deleteViews(id: number): Promise<void> {
  await apiJson<void>(`/p/views/${id}`, { method: 'DELETE' });
}
